import { TabStyles } from '@tableau/widgets';
import * as React from 'react';
import { classes, cssClass } from '../../style';
import { ContentDraftStatus } from '../../ts/ServerApi/types/ContentDraft';
import { localizeDraftStatus } from '../utils/DraftUtils';
import { CommonStyles } from '../../common/react/CommonStyles';

export type DraftMarkerProps = {
  readonly draftStatus: string;
  readonly additionalClass?: string;
};

const DraftMarkerClass = cssClass('DraftMarker', '', {
  height: '20px',
  lineHeight: '20px',
  border: `1px solid ${TabStyles!.Colors!.L8}`,
  boxSizing: 'border-box',
  borderRadius: '3px',
  padding: `0 ${TabStyles!.Spacing!.DefaultSpace}px`,
  fontWeight: 'bold',
  color: CommonStyles.Colors.HyperlinkBlueHover,
  borderColor: CommonStyles.Colors.HyperlinkBlueHover,
});

export const DraftExploreMarkerClass = cssClass('DraftExploreMarker', '', {
  height: `${TabStyles.Spacing.LargeSpace}px`,
  lineHeight: `${TabStyles.Spacing.LargeSpace}px`,
  marginRight: `${TabStyles!.Spacing!.DefaultSpace}px`,
  backgroundColor: TabStyles!.Colors!.F3,
  border: 'none',
  fontWeight: 'normal',
  fontSize: `${TabStyles!.Typography!.Sizing!.Default}px`,
  color: TabStyles.Typography.Color.Primary,
});

export function DraftMarker(props: DraftMarkerProps): JSX.Element {
  return (
    <div className={classes(DraftMarkerClass, props.additionalClass)}>
      <span>{localizeDraftStatus(props.draftStatus)}</span>
    </div>
  );
}

export function renderMarkersForStatus(status: string) {
  let DraftStatusMarkers = [];
  switch(status) {
    case ContentDraftStatus.unpublishedchanges:
      DraftStatusMarkers.push(<DraftMarker key={ContentDraftStatus.unpublishedchanges} draftStatus={ContentDraftStatus.unpublishedchanges} additionalClass={DraftExploreMarkerClass} />);
      break;
    case ContentDraftStatus.unpublished:
      DraftStatusMarkers.push(<DraftMarker key={ContentDraftStatus.unpublishedchanges} draftStatus={ContentDraftStatus.unpublishedchanges} additionalClass={DraftExploreMarkerClass} />);
      DraftStatusMarkers.push(<DraftMarker key={ContentDraftStatus.unpublished} draftStatus={ContentDraftStatus.unpublished} additionalClass={DraftExploreMarkerClass} />);
      break;
    case ContentDraftStatus.none:
      break;
    default:
  }
  return DraftStatusMarkers;
}
